var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"laybg"},[_c('wheader',{attrs:{"currtabs":_vm.currPage}}),_c('router-view'),_c('wfooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }